import React from 'react';

import Image from 'components/Image';

import PossibleDisplayQuality from '../PossibleDisplayQuality';
import ProfileLink from '../ProfileLink';
import myselfProfilePropTypes from '../prop-types';

export default function ProfileSmDown(props) {
  const {
    avatarImage,
    canChangeFaceForFree,
    changeJournalPrivacy,
    journalIsPrivate,
    mantelpieceItemId,
    name,
    scrapbookStatusId,
    viewCameos,
  } = props;

  return (
    <div className="row profile-card profile-card--xs">
      <h2 className="heading heading--2 profile-card__header profile-card__header--xs"
          style={{ paddingLeft: '5px' }}>Cameo &amp; Profile</h2>
      <div className="profile-card__column-container">
        <div className="profile-card__left-col">
          {' '}
          {/* left side  */}
          <div className="profile-card__left-col-card ">
            <Image
              borderContainerClassName="myself-profile__cameo-border myself-profile__cameo-border--sm-down"
              className="myself-profile__cameo myself-profile__cameo--sm-down"
              icon={avatarImage}
              alt="You"
              type="cameo"
              border
            />
          </div>
          <button
            onClick={viewCameos}
            className="button button--primary"
            type="button"
          >
            {canChangeFaceForFree ? 'Change face' : 'View cameos'}
          </button>
        </div>
        <div
          className="profile-card__right-col"
          style={{ backgroundImage: 'url(https://images.fallenlondon.com/images/static/bg-paper-watermark.png)', }}
        >
          {' '}
          {/* right side  */}
          <div className="profile-card__mantelpiece-and-scrapbook">
            <div className="profile-card__mantelpiece">
              {' '}
              {/* mantelpiece */}
              <h3 className="heading heading--3">Mantelpiece</h3>
              <ul className="display-quality__item">
                <PossibleDisplayQuality
                  itemId={mantelpieceItemId}
                  nature="Thing"
                />
              </ul>
            </div>
            <div className="profile-card__scrapbook">
              {' '}
              {/* scrapbook */}
              <h3 className="heading heading--3">Scrapbook</h3>
              <ul className="display-quality__item">
                <PossibleDisplayQuality
                  itemId={scrapbookStatusId}
                  nature="Status"
                />
              </ul>
            </div>
          </div>
          <div className="profile-card__view-profile-container">
            <div>
              <label>
                <input name="hideProfile" type="checkbox" checked={journalIsPrivate} onChange={changeJournalPrivacy} />
                Private
              </label>
              <div
                className="js-buttonlet-help buttonlet buttonlet--help fa-stack js-tt"
                style={{ marginLeft: '4px', position: 'relative' }}
                title="Checking this will prevent you from appearing as a suggested contact for social actions"
              >
                <i className="fa fa-circle fa-stack-2x" />
                <i className="fa fa-question fa-stack-1x fa-inverse" />
                <span className="u-visually-hidden">Help</span>
              </div>
            </div>
            <div>
              <div>
                <ProfileLink name={name} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ProfileSmDown.displayName = 'ProfileSmDown';

ProfileSmDown.propTypes = {
  ...myselfProfilePropTypes,
};